import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	LABELS_TYPE,
	LABELS_CF_TYPE,
	ISSUE_FIELD_MULTI_SELECT_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

const defaultSchema = {
	configuration: null,
	items: 'string' as const,
	type: ISSUE_FIELD_MULTI_SELECT_CF_TYPE,
	renderer: PLAIN_TEXT,
};

export const transformAggLabelsNodeToLegacyField: FieldTransformer<
	typeof LABELS_TYPE | typeof LABELS_CF_TYPE
> = (node) => {
	const selectedLabels = transformAggConnection(node.selectedLabelsConnection, ({ name }) => name);

	switch (node.type) {
		case LABELS_TYPE:
			return {
				...transformAggNodeToLegacyField(node),
				value: selectedLabels,
				schema: {
					...defaultSchema,
					custom: null,
					system: node.type,
				},
			};
		case LABELS_CF_TYPE:
			return {
				...transformAggNodeToLegacyField(node),
				// empty value for custom labels field is null while system labels field is `[]`
				value: selectedLabels.length === 0 ? null : selectedLabels,
				schema: {
					...defaultSchema,
					custom: node.type,
					system: null,
				},
			};
		default:
			return undefined;
	}
};
